export const REQUEST_SMS_CONFIG = 'REQUEST_SMS_CONFIG'
export const SET_SMS_CONFIG = 'SET_SMS_CONFIG'
